import ProjectData from '@/data/ProjectData.ts'

export default [
  new ProjectData("project-01", "AiMalgam", "img/projects/aimalgam.jpeg", `

        <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/aimal/p1.webp" alt="Screenshot">
        <img class="pc-screenshot" src="img/projects/aimal/p2.webp" alt="Screenshot">
        <img class="pc-screenshot" src="img/projects/aimal/p3.webp" alt="Screenshot">
        <img class="pc-screenshot" src="img/projects/aimal/p4.webp" alt="Screenshot">
        </div>

          <div class="paragraph center">
        Check out the package <a
            href="https://assetstore.unity.com/packages/tools/behavior-ai/aimalgam-the-ai-system-for-any-game-218556" target="_blank"
            rel="noopener noreferrer">here</a>!
        </div>

        <div class="paragraph">
        <strong>Description:</strong>
        </div>

<div class="_1_3uP _1rkJa" data-reactid="308">
    <p>Classic AI patterns, such as <strong>behavior </strong>and <strong>decision trees</strong> usually <strong>force
            you</strong> to traverse the entire decision tree to execute (simple) actions...</p>
    <p>This is a <strong>huge waste of performance</strong>, since many actions like entity spotting or movement can in
        theory run independently.</p>
    <p><strong>AiMalgam solves those issues</strong> by separating the decision-making process from action execution,
        while also <strong>providing support for event driven</strong> implementations!</p>
    <p>This asset pack is based on <a
            href="https://aimalgam.api.core.nikosassets.com/BachelorThesis_NG_ModForPublic.pdf" target="_blank"
            rel="noopener noreferrer">this thesis</a>, which explains the issues, benchmarks and solutions of classic AI
        patterns in depth.</p>
    <p>With AiMalgam you can create <strong>custom AI logic</strong> for <strong>any game genre</strong> for <strong>AAA
        </strong>or smaller game titles that can run on <strong>any device</strong> supported by Unity. There are simply
        <strong>no restrictions!</strong></p>
    <p>Though this AI system does <strong>provide you the tools to create AI for any game type</strong>, it does not
        mean that it already contains those AI implementations, since there are potentially <strong>infinite AI
            behaviors! </strong>You can take a look at the demo section to see what AI behavior can be made and beyond
        that as well!</p>
    <p>Checkout the <a href="https://www.youtube.com/watch?v=AMok7lQs6Xc&amp;list=PLMCZMqGcK6AB13g-zvXjdyzpuSMQ7RxTH"
            target="_blank" rel="noopener noreferrer">video tutorial series</a>, the <a
            href="https://aimalgam.api.core.nikosassets.com/AiMalgam_Documentation.pdf" target="_blank"
            rel="noopener noreferrer">documentation</a> and feel free to join the <a
            href="https://discord.gg/Jng8jhuq8G" target="_blank" rel="noopener noreferrer">discord </a>server for
        support and discussions!</p>
    <p><strong>Features:</strong></p>
    <ul>
        <li>Building AI behavior with the <strong>graph editor</strong></li>
        <li><strong>Debugging AI</strong> at runtime with the graph editor</li>
        <li>Generating new <strong>custom AI scripts </strong>(node settings, Monos, AI logic, etc.)</li>
        <li><strong>Management </strong>of your AI settings</li>
        <li><strong>Event</strong> driven architectures for decision-making</li>
        <li>A well documented <a href="https://aimalgam.api.core.nikosassets.com/annotated.html" target="_blank"
                rel="noopener noreferrer">API </a>and <a
                href="https://aimalgam.api.core.nikosassets.com/AiMalgam_Documentation.pdf" target="_blank"
                rel="noopener noreferrer">manual</a></li>
        <li><a href="https://www.youtube.com/watch?v=AMok7lQs6Xc&amp;list=PLMCZMqGcK6AB13g-zvXjdyzpuSMQ7RxTH"
                target="_blank" rel="noopener noreferrer">Video tutorials</a></li>
        <li>Demo AI behavior implementations</li>
        <li>Supports any game genre</li>
        <li>Supports any creature AI (humanoids, insects, fish, stationary objects, etc.)</li>
        <li>Compatible with <strong>2D</strong> and <strong>3D</strong> environments</li>
        <li>Compatible with <strong>any render pipeline</strong></li>
        <li>Can run on <strong>any OS</strong></li>
        <li>Supports <strong>Unity 2019.4 and ongoing</strong></li>
        <li>Uses custom property drawers</li>
    </ul>
    <p><strong>AI Demos (3D only):</strong></p>
    <ul>
        <li>A simple "Red Light Green Light" scene, similar to "<strong>Squid Game</strong>"</li>
        <li><strong>Hide and Seek</strong> example</li>
        <li>Small <strong>Tower Defense</strong> setup</li>
        <li>Close and distance-based <strong>Combat AI</strong></li>
        <li><strong>Swing, get hit</strong> and <strong>Block </strong>melee <strong>attacks </strong>AI</li>
        <li>Example Conditions and Monos</li>
        <li>Spotting AI</li>
        <li>Animation AI</li>
        <li>Follow AI</li>
        <li>Flee AI</li>
    </ul>
    <p>This asset pack uses third-party components (see the "<strong>Third-Party Notices.txt</strong>" file), such as
        the forked <a href="https://github.com/nikodemgrz/NaughtyAttributes" target="_blank"
            rel="noopener noreferrer">NaughtyAttributes</a> package, <a
            href="https://github.com/nikodemgrz/Unity3DHelperTools" target="_blank"
            rel="noopener noreferrer">Unity3DHelperTools</a>, a highly modified version from <a
            href="https://github.com/Siccity/xNode" target="_blank" rel="noopener noreferrer">XNode </a>and <a
            href="https://github.com/google/material-design-icons" target="_blank" rel="noopener noreferrer">Material
            Icons</a>.</p>
</div>

`),
  new ProjectData("project-02", "Modular Code Packs", "img/projects/ht.jpeg", `


                  <div class="paragraph center">
        Since code packs are not very picture friendly, it is best that just check them out <a
            href="https://github.com/nikodemgrz" target="_blank"
            rel="noopener noreferrer">here</a> :)
        </div>

               <div class="paragraph center">
                       <a
            href="https://github.com/nikodemgrz" target="_blank"
            rel="noopener noreferrer">
        <img class="pc-screenshot" src="img/projects/gitportoflio.png" alt="Screenshot">
        </a>
        </div>

        
           <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/ht/p1.webp" alt="Screenshot">
        <img class="pc-screenshot" src="img/projects/ht/p2.webp" alt="Screenshot">
        <img class="pc-screenshot" src="img/projects/ht/p3.webp" alt="Screenshot">
        <img class="pc-screenshot" src="img/projects/ht/p4.webp" alt="Screenshot">
        </div>


        <div class="paragraph">
        <a
            href="https://github.com/nikodemgrz/Unity3DHelperTools" target="_blank"
            rel="noopener noreferrer">
        <strong>NikosAssets.Helpers:</strong><br>
        </a>


        This package contains a diverse collection of helpful scripts (MonoBehaviours, Math, Logic & Management Helpers, Extensions, etc.) for the Unity3D runtime environment and the Editor as well! 
        </div>


        <div class="paragraph">
                <a
            href="https://github.com/nikodemgrz/NikosAssets.Pooling" target="_blank"
            rel="noopener noreferrer">
        <strong>NikosAssets.Pooling:</strong><br></a>


Pool short-lived objects like projectiles or long-lived objects like environment props or entities.         </div>


        <div class="paragraph">
                <a
            href="https://github.com/nikodemgrz/NikosAssets.Modulize" target="_blank"
            rel="noopener noreferrer">
        <strong>NikosAssets.Modulize:</strong><br></a>


Sometimes you want or rather need your components to always execute in the right order within the Unity function execution order (Awake, Start, Update, etc.). This package offers a solution where you can create and order your own modules (MonoBehaviours).         </div>


                <div class="paragraph">
                        <a
            href="https://github.com/nikodemgrz/NikosAssets.PauseHandler" target="_blank"
            rel="noopener noreferrer">
        <strong>NikosAssets.PauseHandler:</strong><br></a>


Provides ingame pause states and events you can subscribe to, as well as a few optional helper scripts that freeze the time during a pause and handle player inputs to toggle the pause state. Note that this package uses the new inputsystem from unity as a dependency.         </div>


                <div class="paragraph">
                        <a
            href="https://github.com/nikodemgrz/NikosAssets.Interactions" target="_blank"
            rel="noopener noreferrer">
        <strong>NikosAssets.Interactions:</strong><br></a>


This package provides basic 3D interaction wrappers with events such as Hover, UnHover and Interact. The interaction logic via raycasts targeted at colliders is included as well, though you need to implement your own input mechanics to trigger the interactions and update the hover callbacks at your own pace/ liking.         </div>

    `),
  new ProjectData("project-03", "PBR Rocks Pack 1", "img/projects/rpack1.jpeg", `

    
            <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/rp1/p1.webp" alt="Screenshot">
        <img class="pc-screenshot" src="img/projects/rp1/p2.webp" alt="Screenshot">
        <img class="pc-screenshot" src="img/projects/rp1/p3.webp" alt="Screenshot">
        <img class="pc-screenshot" src="img/projects/rp1/p4.webp" alt="Screenshot">
        </div>

          <div class="paragraph center">
        Check out the package <a
            href="https://assetstore.unity.com/packages/3d/environments/landscapes/environmental-rocks-pack-vol-1-pbr-190830" target="_blank"
            rel="noopener noreferrer">here</a>!
        </div>

        <div class="paragraph">
        <strong>Description:</strong>
        </div>
    
<div class="_1_3uP _1rkJa" data-reactid="555"><p>
This asset pack contains a set of high quality handmade 3D Models with photoscanned texture maps for all your AAA needs!</p>
<p>You can spice up your terrain/ maps or build entire caves &amp; cliffs with this pack!</p>

<p>Supported Unity Versions &amp; 
Pipelines</p><ul><li>Minimum required Unity version - 2018.4 LTS</li><li>HDRP 7.4.3 - 10.x support</li><li>URP 7.4.3 - 10.x support</li></ul>


        <div class="paragraph">
        <strong>Technical Details:</strong>
        </div>

        <div class="_1_3uP _1rkJa" data-reactid="564">
  <ul>
    <li><strong>37</strong> base FBX <strong>3D models </strong></li>
    <li>
      Each model has <strong>4 LOD</strong> meshes resulting in
      <strong>148 </strong>total <strong>meshes</strong>
    </li>
    <li>All meshes are triangulated</li>
    <li>All meshes are UV unwrapped - Non-overlapping</li>
    <li>
      <strong>Each </strong>model contains <strong>4 texture maps:</strong>
    </li>
      <li>
    Resulting in
    <strong>148 textures</strong> in total
  </li>
    <li>
    <strong> 4096px*4096px</strong> texture
    resolution
  </li>
  <li><strong> PBR</strong></li>
  <li>
    <strong> </strong>Albedo, Normal, AO,
    Roughness
  </li>
  <li><strong> </strong>PNG file format</li>

    <li>Metalness workflow</li>
    <li>
      <strong>Total </strong>Polygon Count of
      <strong>all 37 Meshes</strong> summarized
    </li>
      <li>
    <strong> </strong>LOD0 - 148.786 Polygons
  </li>
  <li><strong> </strong>LOD3 - 7.405 Polygons</li>
  <li><strong> </strong>LOD0 - 76.194 Vertices</li>
  <li><strong> </strong>LOD3 - 4.133 Vertices</li>
  </ul>


</div>



    `),
  new ProjectData("project-04", "PBR Rocks Pack 2", "img/projects/rpack2.jpeg", `

           <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/rp2/p1.webp" alt="Screenshot">
        <img class="pc-screenshot" src="img/projects/rp2/p2.webp" alt="Screenshot">
        <img class="pc-screenshot" src="img/projects/rp2/p3.webp" alt="Screenshot">
        <img class="pc-screenshot" src="img/projects/rp2/p4.webp" alt="Screenshot">
        </div>

          <div class="paragraph center">
        Check out the package <a
            href="https://assetstore.unity.com/packages/3d/environments/landscapes/environmental-rocks-pack-vol-2-pbr-224730" target="_blank"
            rel="noopener noreferrer">here</a>!
        </div>

        <div class="paragraph">
        <strong>Description:</strong>
        </div>
    
<div class="_1_3uP _1rkJa" data-reactid="555"><p>
This asset pack contains a set of high quality handmade 3D Models with photoscanned texture maps for all your AAA needs!</p>
<p>You can spice up your terrain/ maps or build entire caves &amp; cliffs with this pack!</p>

<p>Supported Unity Versions &amp; 
Pipelines</p><ul><li>Minimum required Unity version - 2018.4 LTS</li><li>HDRP 7.4.3 - 10.x support</li><li>URP 7.4.3 - 10.x support</li></ul>

        <div class="paragraph">
        <strong>Technical Details:</strong>
        </div>

        <div class="_1_3uP _1rkJa" data-reactid="564">
  <ul>
    <li><strong>37</strong> base FBX <strong>3D models </strong></li>
    <li>
      Each model has <strong>4 LOD</strong> meshes resulting in
      <strong>148 </strong>total <strong>meshes</strong>
    </li>
    <li>All meshes are triangulated</li>
    <li>All meshes are UV unwrapped - Non-overlapping</li>
    <li>
      <strong>Each </strong>model contains <strong>4 texture maps:</strong>
    </li>
      <li>
    Resulting in
    <strong>148 textures</strong> in total
  </li>
    <li>
    <strong> 4096px*4096px</strong> texture
    resolution
  </li>
  <li><strong> PBR</strong></li>
  <li>
    <strong> </strong>Albedo, Normal, AO,
    Roughness
  </li>
  <li><strong> </strong>PNG file format</li>

    <li>Metalness workflow</li>
    <li>
      <strong>Total </strong>Polygon Count of
      <strong>all 37 Meshes</strong> summarized
    </li>
      <li>
    <strong> </strong>LOD0 - 148.786 Polygons
  </li>
  <li><strong> </strong>LOD3 - 7.405 Polygons</li>
  <li><strong> </strong>LOD0 - 76.194 Vertices</li>
  <li><strong> </strong>LOD3 - 4.133 Vertices</li>
  </ul>


</div>

    
    
    `),
  new ProjectData("project-05", "PBR Rocks Pack 3", "img/projects/rpack3.jpeg", `

           <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/rp3/p1.webp" alt="Screenshot">
        <img class="pc-screenshot" src="img/projects/rp3/p2.webp" alt="Screenshot">
        <img class="pc-screenshot" src="img/projects/rp3/p3.webp" alt="Screenshot">
        <img class="pc-screenshot" src="img/projects/rp3/p4.webp" alt="Screenshot">
        </div>

          <div class="paragraph center">
        Check out the package <a
            href="https://assetstore.unity.com/packages/3d/environments/landscapes/environmental-rocks-pack-vol-3-pbr-226861" target="_blank"
            rel="noopener noreferrer">here</a>!
        </div>

        <div class="paragraph">
        <strong>Description:</strong>
        </div>
    
<div class="_1_3uP _1rkJa" data-reactid="555"><p>
This asset pack contains a set of high quality handmade 3D Models with photoscanned texture maps for all your AAA needs!</p>
<p>You can spice up your terrain/ maps or build entire caves &amp; cliffs with this pack!</p>

<p>Supported Unity Versions &amp; 
Pipelines</p><ul><li>Minimum required Unity version - 2018.4 LTS</li><li>HDRP 7.4.3 - 10.x support</li><li>URP 7.4.3 - 10.x support</li></ul>

        <div class="paragraph">
        <strong>Technical Details:</strong>
        </div>

        <div class="_1_3uP _1rkJa" data-reactid="564">
  <ul>
    <li><strong>37</strong> base FBX <strong>3D models </strong></li>
    <li>
      Each model has <strong>4 LOD</strong> meshes resulting in
      <strong>148 </strong>total <strong>meshes</strong>
    </li>
    <li>All meshes are triangulated</li>
    <li>All meshes are UV unwrapped - Non-overlapping</li>
    <li>
      <strong>Each </strong>model contains <strong>4 texture maps:</strong>
    </li>
      <li>
    Resulting in
    <strong>148 textures</strong> in total
  </li>
    <li>
    <strong> 4096px*4096px</strong> texture
    resolution
  </li>
  <li><strong> PBR</strong></li>
  <li>
    <strong> </strong>Albedo, Normal, AO,
    Roughness
  </li>
  <li><strong> </strong>PNG file format</li>

    <li>Metalness workflow</li>
    <li>
      <strong>Total </strong>Polygon Count of
      <strong>all 37 Meshes</strong> summarized
    </li>
      <li>
    <strong> </strong>LOD0 - 148.786 Polygons
  </li>
  <li><strong> </strong>LOD3 - 7.405 Polygons</li>
  <li><strong> </strong>LOD0 - 76.194 Vertices</li>
  <li><strong> </strong>LOD3 - 4.133 Vertices</li>
  </ul>


</div>

    
    `),
  new ProjectData("project-06", "PBR Rocks Pack 4", "img/projects/rpack4.jpeg", `

           <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/rp4/p1.webp" alt="Screenshot">
        <img class="pc-screenshot" src="img/projects/rp4/p2.webp" alt="Screenshot">
        <img class="pc-screenshot" src="img/projects/rp4/p3.webp" alt="Screenshot">
        <img class="pc-screenshot" src="img/projects/rp4/p4.webp" alt="Screenshot">
        </div>

          <div class="paragraph center">
        Check out the package <a
            href="https://assetstore.unity.com/packages/3d/environments/landscapes/environmental-rocks-pack-vol-4-pbr-226923" target="_blank"
            rel="noopener noreferrer">here</a>!
        </div>

        <div class="paragraph">
        <strong>Description:</strong>
        </div>
    
<div class="_1_3uP _1rkJa" data-reactid="555"><p>
This asset pack contains a set of high quality handmade 3D Models with photoscanned texture maps for all your AAA needs!</p>
<p>You can spice up your terrain/ maps or build entire caves &amp; cliffs with this pack!</p>

<p>Supported Unity Versions &amp; 
Pipelines</p><ul><li>Minimum required Unity version - 2018.4 LTS</li><li>HDRP 7.4.3 - 10.x support</li><li>URP 7.4.3 - 10.x support</li></ul>

        <div class="paragraph">
        <strong>Technical Details:</strong>
        </div>

        <div class="_1_3uP _1rkJa" data-reactid="564">
  <ul>
    <li><strong>37</strong> base FBX <strong>3D models </strong></li>
    <li>
      Each model has <strong>4 LOD</strong> meshes resulting in
      <strong>148 </strong>total <strong>meshes</strong>
    </li>
    <li>All meshes are triangulated</li>
    <li>All meshes are UV unwrapped - Non-overlapping</li>
    <li>
      <strong>Each </strong>model contains <strong>4 texture maps:</strong>
    </li>
      <li>
    Resulting in
    <strong>148 textures</strong> in total
  </li>
    <li>
    <strong> 4096px*4096px</strong> texture
    resolution
  </li>
  <li><strong> PBR</strong></li>
  <li>
    <strong> </strong>Albedo, Normal, AO,
    Roughness
  </li>
  <li><strong> </strong>PNG file format</li>

    <li>Metalness workflow</li>
    <li>
      <strong>Total </strong>Polygon Count of
      <strong>all 37 Meshes</strong> summarized
    </li>
      <li>
    <strong> </strong>LOD0 - 148.786 Polygons
  </li>
  <li><strong> </strong>LOD3 - 7.405 Polygons</li>
  <li><strong> </strong>LOD0 - 76.194 Vertices</li>
  <li><strong> </strong>LOD3 - 4.133 Vertices</li>
  </ul>


</div>

    
    `),
  new ProjectData("project-07", "PBR Rocks Pack 5", "img/projects/rpack5.jpeg", `

           <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/rp5/p1.webp" alt="Screenshot">
        <img class="pc-screenshot" src="img/projects/rp5/p2.webp" alt="Screenshot">
        <img class="pc-screenshot" src="img/projects/rp5/p3.webp" alt="Screenshot">
        <img class="pc-screenshot" src="img/projects/rp5/p4.webp" alt="Screenshot">
        </div>

          <div class="paragraph center">
        Check out the package <a
            href="https://assetstore.unity.com/packages/3d/environments/landscapes/environmental-rocks-pack-vol-5-funky-pbr-226924" target="_blank"
            rel="noopener noreferrer">here</a>!
        </div>

        <div class="paragraph">
        <strong>Description:</strong>
        </div>
    
<div class="_1_3uP _1rkJa" data-reactid="555"><p>
This asset pack contains a set of high quality handmade 3D Models with photoscanned texture maps for all your AAA needs!</p>
<p>You can spice up your terrain/ maps or build entire caves &amp; cliffs with this pack!</p>

<p>Supported Unity Versions &amp; 
Pipelines</p><ul><li>Minimum required Unity version - 2018.4 LTS</li><li>HDRP 7.4.3 - 10.x support</li><li>URP 7.4.3 - 10.x support</li></ul>

        <div class="paragraph">
        <strong>Technical Details:</strong>
        </div>

        <div class="_1_3uP _1rkJa" data-reactid="564">
  <ul>
    <li><strong>37</strong> base FBX <strong>3D models </strong></li>
    <li>
      Each model has <strong>4 LOD</strong> meshes resulting in
      <strong>148 </strong>total <strong>meshes</strong>
    </li>
    <li>All meshes are triangulated</li>
    <li>All meshes are UV unwrapped - Non-overlapping</li>
    <li>
      <strong>Each </strong>model contains <strong>4 texture maps:</strong>
    </li>
      <li>
    Resulting in
    <strong>148 textures</strong> in total
  </li>
    <li>
    <strong> 4096px*4096px</strong> texture
    resolution
  </li>
  <li><strong> PBR</strong></li>
  <li>
    <strong> </strong>Albedo, Normal, AO,
    Roughness
  </li>
  <li><strong> </strong>PNG file format</li>

    <li>Metalness workflow</li>
    <li>
      <strong>Total </strong>Polygon Count of
      <strong>all 37 Meshes</strong> summarized
    </li>
      <li>
    <strong> </strong>LOD0 - 148.786 Polygons
  </li>
  <li><strong> </strong>LOD3 - 7.405 Polygons</li>
  <li><strong> </strong>LOD0 - 76.194 Vertices</li>
  <li><strong> </strong>LOD3 - 4.133 Vertices</li>
  </ul>


</div>

    
    `)
];